import React from "react";
import { Band, Glow, Eyebrow, Reveal } from "./shared";
import { APP_IMG, WEEK_CHIPS, APP_FEATURES } from "./content";

export function AppSection() {
  return (
    <Band id="app" tone="alt">
      <Glow className="bottom-0 left-1/4 w-[460px] h-[460px] bg-[#F59E0B]/8" />
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <Eyebrow className="text-[#22D3EE]">The Software</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mt-3 leading-[1.05]">
            Your 4-week course, in your pocket
          </h2>
          <p className="text-base text-[#B8C7DC] mt-5">
            A guided daily experience that reprograms the mind-body pain loop.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {WEEK_CHIPS.map(([w, t]) => (
              <span key={w} className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-4 py-2 text-sm">
                <span className="text-[#22D3EE] font-semibold">{w}</span>
                <span className="text-[#C7D6EA]">{t}</span>
              </span>
            ))}
          </div>
          <div className="mt-7 bps-eyebrow text-[#22D3EE]">Your Journey Includes</div>
          <div className="mt-4 grid sm:grid-cols-2 gap-4">
            {APP_FEATURES.map((f) => (
              <div key={f.practice} className="bps-card p-5 border-l-2" style={{ borderLeftColor: f.c }} data-testid={`app-feature-${f.practice.split(" ")[1]}`}>
                <div className="text-[10px] font-mono uppercase tracking-[0.18em]" style={{ color: f.c }}>
                  {f.practice} · {f.name}
                </div>
                <div className="font-display font-semibold text-white mt-1.5 leading-snug">{f.t}</div>
                <div className="text-sm text-[#9AAEC6] mt-1 leading-relaxed">{f.d}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="relative flex justify-center">
            <Glow className="inset-0 w-full h-full bg-[#22D3EE]/12" />
            <div className="relative rounded-[2rem] overflow-hidden border border-white/10 shadow-[0_40px_90px_rgba(0,0,0,0.6)] w-full max-w-[460px]">
              <img src={APP_IMG} alt="Freedom From Back Pain web app — you stronger, freer, limitless" className="w-full object-cover" data-testid="app-image" />
            </div>
          </div>
        </Reveal>
      </div>
    </Band>
  );
}
